module.exports = __webpack_public_path__ + "img/no.99c8dc30.png";